module.exports = "<body class=\"gray-bg\">\r\n    <div class=\"middle-box text-center animated fadeInDown\">\r\n        <h1>404</h1>\r\n        <h3 class=\"font-bold\">{{currentPage}}</h3>\r\n\r\n        <div class=\"error-desc\">\r\n            Không tìm thấy trang yêu cầu, vui lòng kiểm tra lại đường dẫn\r\n            <br/><br/>\r\n            <a href=\"\">Trở lại trang chủ</a>\r\n        </div>\r\n    </div>\r\n\r\n</body>"


//////////////////
// WEBPACK FOOTER
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/404/404.component.html
// module id = ../../../../../src/app/404/404.component.html
// module chunks = main